import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { TramiteSicProteccionConsumidorDto } from '../../../../../dto/tramites/tramite-sic-proteccion-consumidor.dto';
import { ListaValorService } from '../services/lista-valor.service';
import { FormField, FormFieldOption } from '../../../../../dto/util/form-field';
import {
  ListaValorRequestDto,
  ListaValorResponseDto,
} from '../../../../../dto/tramites/lista_valor.dto';
import { Constants } from '../../../../../constants/constants';
import { TranslateService } from '@ngx-translate/core';
import { ArchivoItemDto } from '../../../../util/archivos-tramite/dto/ArchivoItemDto';
import { AnexoPrecargaResponseDto } from "../../../../../dto/anexo/anexo-tramite.dto";
import { TipoAnexoTipoTramiteDto } from "../../../../util/archivos-tramite/dto/tipo-anexo-tipo-tramite.dto";
import { ProteccionConsumidorService } from "../services/proteccion-consumidor.service";
import { combineLatest } from 'rxjs';
import { AlertaModalService } from '../../../../../services/util/alerta-modal.service';
@Component({
  selector: 'app-reclamo-directo',
  templateUrl: './reclamo-directo.component.html',
  styleUrl: './reclamo-directo.component.scss',
})
export class ReclamoDirectoComponent implements OnInit, OnChanges {
  @Input() tramiteSic?: TramiteSicProteccionConsumidorDto;
  @Output() continuar = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: Event;
  }>();
  @Output() guardarSinEnviar = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: Event;
  }>();
  @Output() reclamoEmit = new EventEmitter<{
    formReclamo: FormGroup;
  }>();

  entidadId: number = Constants.ID_ENTIDAD_SIC;

  formReclamoDirecto!: FormGroup;
  listaTipoReclamacion: ListaValorResponseDto[] = [];
  maxDay?: string;
  // Multilenguaje
  proconText: any = {}
  comunText: any = {}
  alertaText: any = {};

  // Fechas
  fechaReclamo: unknown;
  fechaRespuesta: unknown;
  // Archivos
  jsonReclamacion: any = {};
  archivosPrecargados: AnexoPrecargaResponseDto[] = [];
  idsFilesPasoTres: TipoAnexoTipoTramiteDto[] = [];
  archivosCargadosPasoTres: ArchivoItemDto[] = [];
  mostrarComponente = false;
  eliminarArchivo: boolean = false;

  festivos: string[] = [];
  constructor(
    private readonly fb: FormBuilder,
    private readonly listaValorService: ListaValorService,
    private readonly translate: TranslateService,
    private readonly proteccionConsumidorService: ProteccionConsumidorService,
    private readonly alertaModalService: AlertaModalService
  ) {

    this.festivos = this.JSON.parse(
      sessionStorage.getItem(Constants.LISTA_FESTIVOS)!
    );
  }

  formFieldsReclamoDirecto: FormField[] = [];

  tipoReclamacion = '';

  recibioRespuesta = '';

  tieneArchivosCargados = false;

  guardarArchivos = false;

  pesoTotalArchivosMB: string = '0.00';


  buildForms() {
    this.formFieldsReclamoDirecto = [
      {
        name: 'tipoReclamacion',
        label: this.proconText['tramite-sic-procon']['atencion-reclamacion'],
        type: 'select',
        required: true,
        options: [],
        width: '12',
        visible: true,
        errorMessages: { required: this.proconText['seleccione-opcion'] },
      },
      {
        name: 'fechaReclamo',
        label: this.proconText['tramite-sic-procon']['fecha-reclamo'],
        type: 'date',
        required: true,
        validation: [],
        width: '12',
        visible: true,
        isMaxDate: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['seleccione-fecha'],
          fueraDeRango:
            this.proconText['tramite-sic-procon']['dar-cumplimiento'],
          invalidRange:
            this.comunText['fecha-invalida'],
        },
        dependsOn: 'tipoReclamacion',
        visibilityCondition: value =>
          value ==
          this.listaTipoReclamacion.find(item => item.Codigo == Constants.RECLAMACION_ESCRITA)
            ?.Id,
      },
      {
        name: 'expidioConstancia',
        label: this.proconText['tramite-sic-procon']['expidio-constancia'],
        type: 'select',
        required: true,
        options: [
          { Id: 'S', Nombre: this.comunText['opcion-si'] },
          { Id: 'N', Nombre: this.comunText['opcion-no'] },
        ],
        width: '12',
        visible: true,
        dependsOn: 'tipoReclamacion',
        visibilityCondition: value =>
          value ==
          this.listaTipoReclamacion.find(item => item.Codigo == Constants.RECLAMACION_VERBAL)
            ?.Id,
        errorMessages: { required: this.proconText['seleccione-opcion'] },
      },
      {
        name: 'recibioRespuesta',
        label: this.proconText['tramite-sic-procon']['recibio-respuesta'],
        type: 'select',
        required: true,
        options: [
          { Id: 'S', Nombre: this.comunText['opcion-si'] },
          { Id: 'N', Nombre: this.comunText['opcion-no'] },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.proconText['seleccione-opcion'] },
      },
      {
        name: 'respuestaReclamoDirecto',
        label: this.proconText['tramite-sic-procon']['respuesta-reclamo'],
        type: 'textarea',
        width: '12',
        visible: true,
        required: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['escribir-respuesta'],
        },
        dependsOn: 'recibioRespuesta',
        visibilityCondition: value => value == 'S',
      },
      {
        name: 'fechaRespuesta',
        label: this.proconText['tramite-sic-procon']['fecha-entrega-respuesta'],
        type: 'date',
        required: true,
        validation: [],
        width: '12',
        visible: true,
        isMaxDate: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['seleccione-fecha'],
          invalidField:
            this.proconText['tramite-sic-procon']['fecha-respuesta-invalida'],
          fueraDeRango:
            this.proconText['tramite-sic-procon']['dar-cumplimiento'],
          invalidRange:
            this.comunText['fecha-invalida'],
        },
        dependsOn: 'recibioRespuesta',
        visibilityCondition: value => value == 'S',
      },
      {
        name: 'manifiesto',
        label: '',
        type: 'checkbox',
        options: [
          {
            Id: 1,
            Nombre: this.proconText['tramite-sic-procon']['juramento'],
          },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.proconText['seleccione-opcion'] },
        dependsOn: 'expidioConstancia',
        visibilityCondition: value => value == 'N',
      },
    ];
  }

  ngOnInit() {
    combineLatest({
      tramites: this.translate.stream('tramites'),
      comun: this.translate.stream('comun-label'),
      alertas: this.translate.stream('alertas'),
    }).subscribe(({ tramites, comun, alertas }) => {
      // Asignar traducciones a variables
      this.proconText = tramites;
      this.comunText = comun;
      this.alertaText = alertas;

      // Construir formularios después de cargar traducciones
      this.buildForms();
    });

    this.formReclamoDirecto = this.fb.group({
    });

    this.fechaMaxima();
    this.listaValor();
  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteSicProteccionConsumidorDto =
      changes['tramiteSic'].currentValue;
    // Si el tramite cambia, se seta toda la informacion del mismo
    if (tramite !== undefined) {
      if (
        tramite.tipoReclamacion?.codigo == Constants.RECLAMACION_ESCRITA ||
        (tramite.tipoReclamacion?.codigo == Constants.RECLAMACION_VERBAL &&
          tramite.expidioConstancia == 'S')
      ) {
        if (this.archivosCargadosPasoTres.length > 0) {
          this.guardarArchivos = true;
        }
      }
      if (this.archivosCargadosPasoTres.length > 0 && this.archivosCargadosPasoTres[0]?.files) {
        this.archivosCargadosPasoTres[0].files.length > 0 ? this.guardarArchivos = true : this.guardarArchivos = false;
      }
      if (tramite.anexos && tramite.anexos.length > 0) {
        this.archivosPrecargados = tramite.anexos;
      }
      if (tramite.tipoReclamacion !== undefined) {
        this.mostrarComponente = true;
        if (tramite.tipoReclamacion.codigo == Constants.RECLAMACION_ESCRITA) {
          this.jsonReclamacion = {
            tipoReclamacion: tramite.tipoReclamacion.codigo,
            recibioRespuesta: tramite.recibioRespuesta ? 'S' : 'N'
          }
        }
        if (tramite.tipoReclamacion.codigo == Constants.RECLAMACION_VERBAL) {
          this.jsonReclamacion = {
            tipoReclamacion: tramite.tipoReclamacion.codigo,
            expidioConstancia: tramite.expidioConstancia
          }
        }
        if (tramite.tipoReclamacion?.codigo == Constants.RECLAMACION_ESCRITA) {
          this.formReclamoDirecto.controls['expidioConstancia'].removeValidators(Validators.required);
          this.formReclamoDirecto.controls['expidioConstancia'].updateValueAndValidity();
        }
        if (tramite.tipoReclamacion?.codigo == Constants.RECLAMACION_VERBAL) {
          this.formReclamoDirecto.controls['expidioConstancia'].addValidators(Validators.required);
          this.formReclamoDirecto.controls['expidioConstancia'].updateValueAndValidity();
          this.formReclamoDirecto.controls['fechaReclamo'].removeValidators([Validators.required,
          this.fechaValidator(this.festivos)]);
          this.formReclamoDirecto.controls['fechaReclamo'].updateValueAndValidity();
        }
        if (tramite.expidioConstancia == 'S') {
          this.formReclamoDirecto.controls['manifiesto'].removeValidators(Validators.required);
          this.formReclamoDirecto.controls['manifiesto'].updateValueAndValidity();
        }
        if (tramite.expidioConstancia == 'N') {
          this.formReclamoDirecto.controls['manifiesto'].addValidators(Validators.required);
          this.formReclamoDirecto.controls['manifiesto'].updateValueAndValidity();
        }
        if (tramite.recibioRespuesta) {
          this.formReclamoDirecto.controls['fechaRespuesta'].addValidators(Validators.required);
          this.formReclamoDirecto.controls['fechaRespuesta'].updateValueAndValidity();
          this.formReclamoDirecto.controls['respuestaReclamoDirecto'].addValidators(Validators.required);
          this.formReclamoDirecto.controls['respuestaReclamoDirecto'].updateValueAndValidity();
        }
        if (!tramite.recibioRespuesta) {
          this.formReclamoDirecto.controls['fechaRespuesta'].removeValidators(Validators.required);
          this.formReclamoDirecto.controls['fechaRespuesta'].updateValueAndValidity();
          this.formReclamoDirecto.controls['respuestaReclamoDirecto'].removeValidators(Validators.required);
          this.formReclamoDirecto.controls['respuestaReclamoDirecto'].updateValueAndValidity();
        }
        this.formFieldsReclamoDirecto = this.formFieldsReclamoDirecto.map(
          field => {
            if (field.name === 'tipoReclamacion') {
              field.value = tramite.tipoReclamacion?.id;
            }
            if (field.name === 'fechaReclamo') {
              if (tramite.fechaReclamo) {
                field.value = this.setDateValue(
                  tramite.fechaReclamo.toString()
                );
              }
            }
            if (field.name === 'recibioRespuesta') {
              field.value = `${tramite.recibioRespuesta ? 'S' : 'N'}`;
            }
            if (field.name === 'manifiesto') {
              field.value = true;
            }
            if (field.name === 'respuestaReclamoDirecto') {
              field.value = `${tramite.respuestaReclamoDirecto}`;
            }
            if (
              field.name === 'fechaRespuesta' &&
              tramite &&
              tramite.fechaRespuesta
            ) {
              field.value = this.setDateValue(
                tramite!.fechaRespuesta!.toString()
              );
            }
            if (field.name === 'expidioConstancia') {
              field.value = `${tramite.expidioConstancia}`;
            }
            return field;
          }
        );

        this.formReclamoDirecto.patchValue({
          tipoReclamacion: tramite.tipoReclamacion?.id,
          fechaReclamo: tramite.fechaReclamo,
          recibioRespuesta: tramite.recibioRespuesta ? 'S' : 'N',
          respuestaReclamoDirecto: tramite.respuestaReclamoDirecto,
          fechaRespuesta: tramite.fechaRespuesta,
          manifiesto: true,
        });
      }
      if (this.tramiteSic?.anexos?.length == 0) {
        if (this.tramiteSic) {
          this.proteccionConsumidorService
            .cargarTramitePendiente(+this.tramiteSic.id!)
            .subscribe((resp: TramiteSicProteccionConsumidorDto) => {
              if (resp.anexos && resp.anexos.length > 0) {
                this.archivosPrecargados = resp.anexos.filter(
                  archivo =>
                    archivo.tipoAnexoTipoTramite.orden == 3
                );
              }
            });
        }
      }
    }
  }

  fechaValidator(festivos: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null; // No validar si no hay valor

      const fechaReclamo = new Date(control.value);
      const fechaMin = new Date();
      let diasHabiles = Constants.DIAS_HABILES;

      while (diasHabiles > 0) {
        fechaMin.setDate(fechaMin.getDate() - 1);
        const fechaStr = fechaMin.toISOString().split('T')[0];
        // Si es sábado (6), domingo (0) o festivo no cuenta como día hábil
        if (fechaMin.getDay() !== 0 && fechaMin.getDay() !== 6 && !festivos.includes(fechaStr)) {
          diasHabiles--;
        }
      }

      if (fechaReclamo > fechaMin) {
        return { fueraDeRango: true };
      }

      return null;
    };
  }

  listaValor() {
    this.listaValorService.lista('SIC_TIPO_RECLAMACION').subscribe(data => {
      const response = data as ListaValorResponseDto[];
      this.listaTipoReclamacion = response;

      this.formFieldsReclamoDirecto = this.formFieldsReclamoDirecto.map(
        field => {
          if (field.name === 'tipoReclamacion') {
            field.options = response.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        }
      );
    });
  }

  validarFormulario(formGroup: FormGroup) {
    this.formReclamoDirecto = formGroup;
    const tipoReclamacionSeleccionado = this.listaTipoReclamacion.find(
      item => item.Id === this.formReclamoDirecto.value['tipoReclamacion']
    );
    if (tipoReclamacionSeleccionado?.Codigo === 'TR_E') {
      setTimeout(() => {
        this.tipoReclamacion = 'Escrita';
      }, 10);
    } else if (tipoReclamacionSeleccionado?.Codigo === 'TR_V') {
      setTimeout(() => {
        this.tipoReclamacion = 'Verbal';
        this.tieneArchivosCargados = true;
      }, 10);
    }
    if (formGroup?.get('fechaRespuesta')?.value) {
      const fechaRespuestaValue = formGroup?.get('fechaRespuesta')?.value;
      if (typeof fechaRespuestaValue === 'string') {
        let auxFecha = new Date(fechaRespuestaValue);
        // Comparar las fechas
        if (auxFecha instanceof Date) {
          const fechaMax = new Date(this.maxDay!);
          if (auxFecha > fechaMax) {
            formGroup?.get('fechaRespuesta')?.setErrors({
              'invalid-date-range': true,
            });
          }
        }
      }
    }
    if (formGroup?.get('fechaReclamo')?.value) {
      const fechaReclamoValue = formGroup?.get('fechaReclamo')?.value;
      if (typeof fechaReclamoValue === 'string') {
        let auxFecha = new Date(fechaReclamoValue);
        // Comparar las fechas
        if (auxFecha instanceof Date) {
          const fechaMax = new Date(this.maxDay!);
          if (auxFecha > fechaMax) {
            formGroup?.get('fechaReclamo')?.setErrors({
              'invalid-date-range': true,
            });
          }
        }
      }
    }
    if (formGroup?.get('recibioRespuesta')?.value) {
      const controlFechaReclamo = this.formReclamoDirecto.controls['fechaReclamo'];
      if (tipoReclamacionSeleccionado?.Codigo === 'TR_E') {
        if (formGroup?.get('recibioRespuesta')?.value == 'S') {
          // Mantener solo required
          controlFechaReclamo.setValidators([
            Validators.required
          ]);

          // Limpiar errores antiguos de la validación de 15 días hábiles
          const errors = controlFechaReclamo.errors;
          if (errors) {
            delete errors['fueraDeRango'];
            if (Object.keys(errors).length === 0) {
              controlFechaReclamo.setErrors(null);
            } else {
              controlFechaReclamo.setErrors(errors);
            }
          }

          controlFechaReclamo.updateValueAndValidity();

        } else {
          // Required + validación personalizada
          controlFechaReclamo.setValidators([
            Validators.required,
            this.fechaValidator(this.festivos)
          ]);
          controlFechaReclamo.updateValueAndValidity();
        }
        const fechaReclamoValue = controlFechaReclamo.value;
        if (typeof fechaReclamoValue === 'string') {
          this.fechaReclamo = new Date(fechaReclamoValue);
          const fechaMax = new Date(this.maxDay!);
          if (this.fechaReclamo instanceof Date) {
            if (this.fechaReclamo > fechaMax) {
              controlFechaReclamo.setErrors({
                'invalid-date-range': true,
              });
            }
          }
        }
      } else {
        controlFechaReclamo.clearValidators();
        controlFechaReclamo.updateValueAndValidity();
      }

    }

    this.reclamoEmit.emit({
      formReclamo: formGroup
    });
  }

  validarCampos(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    if (event.controlName === 'tipoReclamacion') {
      const controlValue = event.controlValue as { Id: number };

      const codigo = this.listaTipoReclamacion.find(
        item => item.Id == controlValue.Id
      )?.Codigo;
      if (codigo == Constants.RECLAMACION_ESCRITA) {
        this.limpiarControles();
        this.formReclamoDirecto.controls['fechaReclamo'].addValidators([Validators.required,
        this.fechaValidator(this.festivos)]);
        this.formReclamoDirecto.controls['fechaReclamo'].updateValueAndValidity();
        this.formReclamoDirecto.controls['expidioConstancia'].reset();
        this.formReclamoDirecto.controls['expidioConstancia'].removeValidators(Validators.required);
        this.formReclamoDirecto.controls['expidioConstancia'].updateValueAndValidity();
      }
      if (codigo == Constants.RECLAMACION_VERBAL) {
        this.limpiarControles();
        this.formReclamoDirecto.controls['expidioConstancia'].addValidators(Validators.required);
        this.formReclamoDirecto.controls['expidioConstancia'].updateValueAndValidity();
        this.formReclamoDirecto.controls['fechaReclamo'].reset();
        this.formReclamoDirecto.controls['fechaReclamo'].removeValidators([Validators.required,
        this.fechaValidator(this.festivos)]);
        this.formReclamoDirecto.controls['fechaReclamo'].updateValueAndValidity();
      }
    }
    if (event.controlName === 'fechaReclamo') {
      // Se convierte el valor de fechaReclamo a string y luego a Date
      const fechaReclamoValue = event.form.controls['fechaReclamo'].value;
      if (typeof fechaReclamoValue === 'string') {
        this.fechaReclamo = new Date(fechaReclamoValue);
        const fechaMax = new Date(this.maxDay!);
        if (this.fechaReclamo instanceof Date) {
          if (this.fechaReclamo > fechaMax) {
            event.form.controls['fechaReclamo'].setErrors({
              'invalid-date-range': true,
            });
          }
        }
      }
    }

    if (event.controlName === 'fechaRespuesta') {
      // Se convierte el valor de fechaRespuesta a string y luego a Date
      const fechaRespuestaValue = event.form.controls['fechaRespuesta'].value;
      if (typeof fechaRespuestaValue === 'string') {
        this.fechaRespuesta = new Date(fechaRespuestaValue);
        // Comparar las fechas
        if (this.fechaReclamo instanceof Date && this.fechaRespuesta instanceof Date) {
          if (this.fechaRespuesta < this.fechaReclamo) {
            event.form.controls['fechaRespuesta'].setErrors({
              'is-invalid': true,
            });
          }
          const fechaMax = new Date(this.maxDay!);
          if (this.fechaRespuesta > fechaMax) {
            event.form.controls['fechaRespuesta'].setErrors({
              'invalid-date-range': true,
            });
          }
        }
      }

    }
    if (event.controlName === 'recibioRespuesta') {
      const valor = event.controlValue as FormFieldOption;
      if (valor.Id == 'S') {
        this.formReclamoDirecto.controls['fechaRespuesta'].addValidators(Validators.required);
        this.formReclamoDirecto.controls['fechaRespuesta'].updateValueAndValidity();
        this.formReclamoDirecto.controls['respuestaReclamoDirecto'].addValidators(Validators.required);
        this.formReclamoDirecto.controls['respuestaReclamoDirecto'].updateValueAndValidity();
      }
      if (valor.Id == 'N') {
        this.formReclamoDirecto.controls['fechaRespuesta'].reset();
        this.formReclamoDirecto.controls['fechaRespuesta'].removeValidators(Validators.required);
        this.formReclamoDirecto.controls['fechaRespuesta'].updateValueAndValidity();
        this.formReclamoDirecto.controls['respuestaReclamoDirecto'].reset();
        this.formReclamoDirecto.controls['respuestaReclamoDirecto'].removeValidators(Validators.required);
        this.formReclamoDirecto.controls['respuestaReclamoDirecto'].updateValueAndValidity();
      }
    }
    if (event.controlName === 'expidioConstancia') {
      const valor = event.controlValue as FormFieldOption;
      if (valor.Id == 'S') {
        this.formReclamoDirecto.controls['manifiesto'].reset();
        this.formReclamoDirecto.controls['manifiesto'].removeValidators(Validators.required);
        this.formReclamoDirecto.controls['manifiesto'].updateValueAndValidity();
      }
      if (valor.Id == 'N') {
        this.formReclamoDirecto.controls['manifiesto'].addValidators(Validators.required);
        this.formReclamoDirecto.controls['manifiesto'].updateValueAndValidity();
      }
      const codigo = this.listaTipoReclamacion.find(
        item => item.Id == event.form.controls['tipoReclamacion'].value
      )?.Codigo;
    }
    if (event.controlName == 'tipoReclamacion' ||
      event.controlName == 'recibioRespuesta' ||
      event.controlName == 'expidioConstancia') {
      this.mostrarComponente = true;
      const codigo = this.listaTipoReclamacion.find(
        item => item.Id == event.form.controls['tipoReclamacion'].value
      )?.Codigo;
      if (codigo == Constants.RECLAMACION_ESCRITA) {
        this.jsonReclamacion = {
          tipoReclamacion: codigo,
          recibioRespuesta: event.form.controls['recibioRespuesta'].value
        }
      } else {
        this.jsonReclamacion = {
          tipoReclamacion: codigo,
          expidioConstancia: event.form.controls['expidioConstancia'].value
        }
      }
      this.borrarArchivosPegados(event.form.valid);
    }
    // this.mostrarCamposRequeridos(event.form);
  }

  limpiarControles(): void {
    this.formReclamoDirecto.patchValue({
      fechaReclamo: null,
      fechaRespuesta: null,
      recibioRespuesta: null,
      expidioConstancia: null,
      respuestaReclamoDirecto: null
    });

    this.formReclamoDirecto.get('fechaReclamo')?.reset();
    this.formReclamoDirecto.get('fechaRespuesta')?.reset();
    this.formReclamoDirecto.get('recibioRespuesta')?.reset();
    this.formReclamoDirecto.get('expidioConstancia')?.reset();
    this.formReclamoDirecto.get('respuestaReclamoDirecto')?.reset();
  }

  mostrarCamposRequeridos(formGroup: FormGroup) {
    const camposRequeridos = Object.keys(formGroup.controls).filter(
      controlName =>
        formGroup.get(controlName)?.hasValidator(Validators.required)
    );
    console.log('Campos requeridos:', camposRequeridos);

  }

  borrarArchivosPegados(validForm: boolean) {
    if (validForm) {
      if (this.eliminarArchivo) {
        this.eliminarArchivo = false;
        setTimeout(() => {
          this.eliminarArchivo = true;
        }, 100);
      } else {
        this.eliminarArchivo = true;
      }
    } else {
      if (this.eliminarArchivo) {
        this.eliminarArchivo = false;
        setTimeout(() => {
          this.eliminarArchivo = true;
        }, 100);
      } else {
        this.eliminarArchivo = true;
      }
    }
    this.guardarArchivos = false;
  }

  anterior() {
    let paso = JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      paso--;
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(paso));
    }
    if (this.archivosCargadosPasoTres.length > 0 && this.archivosCargadosPasoTres[0]?.files) {
      this.archivosCargadosPasoTres[0].files.length > 0 ? this.guardarArchivos = true : this.guardarArchivos = false;
      this.archivosCargadosPasoTres = [];
    }
  }

  pasarAProteccionQueRequiere(event: Event, guardarSinEnviar: boolean) {
    let paso = JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(4));
    }
    const item = this.listaTipoReclamacion.find(
      item => item.Id === this.formReclamoDirecto.value['tipoReclamacion']
    );

    const listaValor: ListaValorRequestDto = {
      valor: item?.Valor,
      estado: item?.Estado,
      nombreLista: item?.Nombre_Lista,
      codigo: item?.Codigo,
      otroValor: item?.Otro_valor,
      idExterno: item?.Id_Externo,
      id: item?.Id,
    };

    const tramite: TramiteSicProteccionConsumidorDto = {
      tipoReclamacion: listaValor,
      fechaReclamo: this.formReclamoDirecto.value['fechaReclamo'],
      recibioRespuesta:
        this.formReclamoDirecto.value['recibioRespuesta'] === 'S',
      respuestaReclamoDirecto:
        this.formReclamoDirecto.value['respuestaReclamoDirecto'],
      fechaRespuesta: this.formReclamoDirecto.value['fechaRespuesta'],
      expidioConstancia: this.formReclamoDirecto.value['expidioConstancia']
    };

    const formValid = this.formReclamoDirecto.valid;

    if (!guardarSinEnviar) {
      this.guardarArchivos = true;
      setTimeout(() => {
        this.continuar.emit({
          tramite: tramite,
          formValid,
          event: event,
        });
      }, 1000);
    } else {
      this.guardarArchivos = true;
      setTimeout(() => {
        this.guardarSinEnviar.emit({
          tramite: tramite,
          formValid,
          event: event,
        });
      }, 1000);
    }
  }

  onClickProteccionRequiere(event: Event) {
    const result = this.validarDocumentosObligatorios(this.formReclamoDirecto);

    if (!result.valido) {

      switch (result.error) {
        case Constants.ANEXOS_INCOMPLETOS:
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['archivos_obligatorios']
          );
          break;

        case Constants.FORM_INVALID:
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['form_invalid']
          );
          this.formReclamoDirecto.markAllAsTouched();
          break;

        default:
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['form_invalid']
          );
          break;
      }

      return;
    }

    // Todo correcto → continúa normalmente
    this.pasarAProteccionQueRequiere(event, false);
  }

  fechaMaxima() {
    const today: Date = new Date();
    const year: number = today.getFullYear();
    const month: string = String(today.getMonth() + 1).padStart(2, '0');
    const day: string = String(today.getDate()).padStart(2, '0');

    this.maxDay = `${year}-${month}-${day}`;
  }

  actualizarValidaciones(valorSeleccion: string) {
    const respuesta = this.formReclamoDirecto.get('respuestaReclamoDirecto');
    const fechaRespuesta = this.formReclamoDirecto.get('fechaRespuesta');
    const manifiesto = this.formReclamoDirecto.get('manifiesto');
    this.recibioRespuesta = valorSeleccion;

    if (valorSeleccion === 'S') {
      respuesta?.setValidators([Validators.required]);
      fechaRespuesta?.setValidators([Validators.required]);
      manifiesto?.clearValidators();
    } else {
      manifiesto?.setValidators([Validators.required]);
      respuesta?.clearValidators();
      fechaRespuesta?.clearValidators();
    }
    respuesta?.updateValueAndValidity();
    fechaRespuesta?.updateValueAndValidity();
    manifiesto?.updateValueAndValidity();
  }

  setDateValue(dateString: string): string | undefined {
    if (!dateString) return; // Manejo de caso nulo o vacío
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.warn(`Fecha inválida: ${dateString}`);
      return;
    } else {
      const formattedDate = date.toISOString().split('T')[0]; // Formato yyyy-MM-dd
      return formattedDate;
    }
  }

  validarArchivosCargados(archivos: ArchivoItemDto[]) {
    // Se validan archivos con el mismo ID, se deja el último.
    // Debido a que, corresponde al momento en que el paso 3 carga el formulario y los anexos
    const data = archivos;
    const unicos = Array.from(
      new Map(data.map(obj => [obj.item.id, obj])).values()
    );
    this.archivosCargadosPasoTres = unicos;
    const totalBytes = this.archivosCargadosPasoTres.reduce(
      (total, archivo) => total + archivo.files.reduce((sum, file) => sum + file.size, 0),
      0
    );
    this.pesoTotalArchivosMB = (totalBytes / (1024 * 1024)).toFixed(2);
  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }

  protected readonly JSON = JSON;
  protected readonly Constants = Constants;
  // Función que retorna los documentos anexados por pasos
  validarAnexosPrecargados(paso: number): AnexoPrecargaResponseDto[] {
    return this.archivosPrecargados.filter(
      archivo =>
        archivo.tipoAnexoTipoTramite.orden == paso
    );
  }
  // Función que almacena los archivos requeridos por cada uno de los pasos
  validarArchivosRequeridos(evento: { archivos: TipoAnexoTipoTramiteDto[]; paso: number }) {
    this.idsFilesPasoTres = this.buscarRequeridos(evento.archivos);
  }
  // Función que retorna los archivos con la propiedad de requerido = true
  buscarRequeridos(archivos: TipoAnexoTipoTramiteDto[]) {
    archivos = archivos.filter(
      (anexo: any) => anexo.requerido === true
    );
    return archivos;
  }
  // Función que verifica si los archivos requeridos están cargados y si el formulario es válido
  validarDocumentosObligatorios(form: FormGroup): { valido: boolean, error?: string } {

    const anexosRequeridosIds = this.idsFilesPasoTres.map((anexo: any) => anexo.id);

    const checkAnexos = this.validarAnexos(
      this.archivosCargadosPasoTres,
      anexosRequeridosIds
    );

    if (!checkAnexos) {
      return {
        valido: false,
        error: Constants.ANEXOS_INCOMPLETOS
      };
    }

    if (!form?.valid) {
      return {
        valido: false,
        error: Constants.FORM_INVALID
      };
    }

    return { valido: true };
  }

  // Función que valida si los archivos anexados, corresponden a los archivos requeridos
  validarAnexos(archivosCargados: ArchivoItemDto[], ids: number[]): boolean {
    let requeridosFull: number = 0;
    let cantidadRequeridos: number = ids.length;
    ids.forEach((elemento: number) => {
      archivosCargados.forEach((anexo: ArchivoItemDto) => {
        if (elemento == anexo.item.id) {
          if (anexo.files.length > 0) {
            requeridosFull++;
          } else {
            requeridosFull--;
          }
        }
      });
    });
    if (requeridosFull == cantidadRequeridos) {
      return true;
    } else {
      return false;
    }
  }
  validarRegla(): boolean {
    if (this.tipoReclamacion == 'Escrita' && this.formReclamoDirecto.get('recibioRespuesta')?.value) {
      return true;
    } else {
      if (this.formReclamoDirecto.get('expidioConstancia')?.value == 'S') {
        return true;
      } else {
        return false;
      }
    }
  }
  // Documentos
  subirArchivo(subio: any) {
    this.guardarArchivos = false;
    if (subio) {
    }
  }
}
